import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import CharacterMakerActorGroup from '../../../domain/entities/CharacterMakerActorGroup';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexCharacterMakerActorGroupsSuccess: {
      const result =
        action.payload as PaginatedResult<CharacterMakerActorGroup>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
